<template>
    <div class="aup-boxloader">
        <div class="aup-boxloader__square"></div>
    </div>
</template>
<script>
	export default {
        name: "BaseBoxLoader"
    };
</script>

<style lang="scss">
    @import "../../assets/scss/all";
    .aup-boxloader {
        width: 69px;
        border: 2px solid $alpha-orange;
        padding: 2px;
        position: relative;

        &__square {
            position: relative;
            height: 6px;
            width: 6px;
            background-color: $alpha-orange;
            transition: all .5s ease-in-out;
            animation: boxSlide 1.3s infinite ease-in-out;
        }

        &__bg {
        width: 100%;
        position: absolute;
        height: 100%;
        background: rgba(0,0,0,.4);
        z-index: map-get($zindices, dropdown);
        display: flex;
        flex-direction: column;
        }

        &--center {
        margin-right: auto;
        margin-left: auto;
        margin-top: calc(50vh - 50px);
        }
    }

    @keyframes boxSlide {
        0% {
        left: 0;
        }
        50% {
        left: 55px;
        }
        100% {
        left: 0;
        }
    }
</style>
